import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";

interface ApplicationFormProps {
  validation: any;
  isEdit?: boolean;
}

const ApplicationForm: React.FC<ApplicationFormProps> = ({
  validation,
  isEdit = false,
}) => {
  return (
    <Row className="g-3">
      {!isEdit && (
        <Col md={12}>
          <Label className="fw-bold mb-1">
            Application ID <span className="text-danger">*</span>
          </Label>
          <Input
            type="number"
            name="applicationid"
            placeholder="Enter application ID"
            value={validation.values.applicationid || ""}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            invalid={
              !!(validation.touched.applicationid && validation.errors.applicationid)
            }
          />
          <FormFeedback>{validation.errors.applicationid}</FormFeedback>
        </Col>
      )}

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Application Name <span className="text-danger">*</span>
        </Label>
        <Input
          type="text"
          name="applicationname"
          placeholder="Enter application name"
          value={validation.values.applicationname || ""}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          invalid={
            !!(validation.touched.applicationname && validation.errors.applicationname)
          }
        />
        <FormFeedback>{validation.errors.applicationname}</FormFeedback>
      </Col>

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Application Description <span className="text-danger">*</span>
        </Label>
        <Input
          type="textarea"
          name="applicationdescription"
          placeholder="Enter application description"
          rows={4}
          value={validation.values.applicationdescription || ""}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          invalid={
            !!(validation.touched.applicationdescription && validation.errors.applicationdescription)
          }
        />
        <FormFeedback>{validation.errors.applicationdescription}</FormFeedback>
      </Col>
    </Row>
  );
};

export default ApplicationForm;
